import { Container, Grid, Box, Typography  } from "@mui/material";

import Input from "@/components/ph/Input";

import FormSection from "../../utils/FormSection";

import { useContractorField } from "../hooks/useContractorField";

const ContractorInitialData = () => {

  const correoField = useContractorField("correoElectronico", {
    validate: (val) => {
      if (!val) return "El correo electrónico es requerido";
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(val) ? "" : "Correo no válido";
    },
  });

  const telefonoField = useContractorField("telefonoMovil", {
    validate: (val) => {
      if (!val) return "El teléfono es requerido";
      const phoneRegex = /^\d{10}$/;
      return phoneRegex.test(val) ? "" : "Debe tener 10 dígitos";
    },
    transformValue: (v) => v.replace(/\D/g, "").slice(0, 10),
  });

  const rfcField = useContractorField("rfc", {
    required: false,
    validate: (val) => {
      if (!val || val.trim() === "") return "";
      
      const cleanRFC = val.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      
      if (cleanRFC.length !== 13) {
        return "El RFC debe tener 13 caracteres";
      }
      
      const rfcRegex = /^[A-Z&Ñ]{3,4}[0-9]{6}[A-Z0-9]{3}$/;
      if (!rfcRegex.test(cleanRFC)) {
        return "Formato de RFC no válido";
      }
      
      return "";
    },
    transformValue: (v) => {
      return v.replace(/[^a-zA-Z0-9]/g, "").toUpperCase().slice(0, 13);
    },
    onKeyDown: (e) => {
      const allowedKeys = [
        'Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 
        'Home', 'End', 'Enter'
      ];
      
      if (allowedKeys.includes(e.key)) return;
      if (!/^[a-zA-Z0-9&]$/.test(e.key)) {
        e.preventDefault();
      }
      if (e.target.value.length >= 13 && !allowedKeys.includes(e.key)) {
        e.preventDefault();
      }
    },
  });


  return (
    <Container maxWidth="md" disableGutters={{ xs: true, md: false }}>
      <FormSection title="DATOS DE CONTACTO DEL CONTRATANTE">
        <Grid container spacing={2} size={{ xs: 12, md: 12 }} >
          <Grid size={{ xs: 12, md: 6 }}>
            <Box sx={{ minHeight: '3.5rem', display: 'flex', alignItems: 'flex-end' }}>
              <Input
                errorMessage={correoField.getErrorMessage()}
                isInvalid={correoField.isInvalid}
                label="Correo Electrónico"
                name="correoElectronico"
                value={correoField.value}
                {...correoField.handlers}
                required
                type="text"
              />
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box sx={{ minHeight: '3.5rem', display: 'flex', alignItems: 'flex-end' }}>
              <Input
                errorMessage={telefonoField.getErrorMessage()}
                isInvalid={telefonoField.isInvalid}
                label="Teléfono Móvil (10 digitos)"
                name="telefonoMovil"
                value={telefonoField.value}
                {...telefonoField.handlers}
                required
                type="text"
              />
            </Box>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <Typography variant="body1" sx={{ color: "text.secondary", mt: 1, mb: 1}}>
              BENEFICIOS SOY CLIENTE GNP (Opcional) 
            </Typography>
            <Typography variant="body1" sx={{ color: "text.secondary", fontSize: ".9rem"}}>
              Descubre si eres acredor a alguno de los beneficios exclusivos que GNP tiene para ti.
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 12 }}>
            <Box sx={{ minHeight: '3.5rem', display: 'flex', alignItems: 'flex-end' }}>
              <Input
                errorMessage={rfcField.getErrorMessage()}
                isInvalid={rfcField.isInvalid}
                label="RFC + homoclave"
                name="rfc"
                value={rfcField.value}
                {...rfcField.handlers}
                type="text"
              />
            </Box>
          </Grid>
        </Grid>
      </FormSection>
    </Container>
  );
};

export default ContractorInitialData;
